module.exports = __webpack_public_path__ + "static/img/logo.e8a6a542.svg";